import React, { useEffect, useState, useRef } from 'react';
import * as _ from 'lodash';

export default function Parts(props) {
  const [parts, setParts] = useState(props.parts);
  const [partsConf, setPartsConf] = useState(props.confParts);
  const [cat, setCat] = useState(null);
  const type = useRef();
  const quantity = useRef();
  const reinvoice = useRef();
  useEffect(() => {
    document.getElementsByName(props.fieldName)[0].value = JSON.stringify(parts);
  }, [parts]);

  return (<div>
    <table className="form-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Nazwa części</th>
          <th>Jednostka</th>
          <th>Ilość</th>
          <th>Refaktura</th>
          <th>Usuń</th>
        </tr>
      </thead>
      <tbody>
        {!parts || parts.length < 1 && <tr>
          <td colSpan={4}>Nie wykorzystano żadnych części</td>
        </tr>}
        {_.map(parts, (part, i) => {
          return (
            <tr>
              <td>{i + 1}</td>
              <td>{part.label}</td>
              <td>{part.unit}</td>
              <td>{part.quantity}</td>
              <td>{part.reinvoice == 1 ? 'Tak' : 'Nie'}</td>
              <td><a onClick={e => {
                const newParts = Object.assign([], parts);
                newParts.splice(i, 1);
                setParts(newParts);
              }}><i className="fas fa-trash"></i></a></td>
            </tr>
          )
        })}
      </tbody>
    </table>
    <div className="parts-fieldsets">
      <fieldset>
        <fieldset>
          <legend>Dodaj część</legend>
          <label>
            <span>Kategoria części</span>
            <select onChange={e => {
              setCat(e.currentTarget.value);
            }}>
              <option key={`part-category-choose`} value={null}>-- wybierz --</option>
              {_.map(partsConf, (cat, catId) => (
                <option key={`part-category-${cat.name}`} value={catId}>{cat.name}</option>))}
            </select>
          </label>
          <label>
            <span>Część</span>
            <select ref={type} disabled={!(cat && partsConf[cat])}>
              {_.map(cat && partsConf[cat] ? partsConf[cat]['stock'] : [],
                part => {
                  const cPart = _.find(parts, i => i.id === part.id && !i.release_id);
                  let avQ = part.availableQuantity;
                  if (cPart) {
                    avQ -= cPart.quantity;
                  }
                  return (
                    <option key={`part-type-${part.id}`} value={part.id}>{part.label} (dostępna
                      ilość: {avQ})</option>
                  )
                })}
            </select>
          </label>
          <label>
            <span>Ilość</span>
            <input ref={quantity} type="number" min="1" max="99" defaultValue={1} />
          </label>
          <label>
            <span>Refaktura</span>
            <select ref={reinvoice}>
              <option key={`part-reinvoice-no`} value={0}>NIE</option>
              <option key={`part-reinvoice-yes`} value={1}>TAK</option>
            </select>
          </label>
          <a className="button hollow" onClick={e => {
            const partConf = _.find(partsConf[cat]['stock'], { id: type.current.value });
            const currPart = _.findIndex(parts, i => i.id === type.current.value && !i.release_id);

            const newQuantity = parseInt(quantity.current.value) + parseInt(currPart !== -1 ? parts[currPart].quantity : 0);
            if (partConf.availableQuantity < newQuantity) {
              alert('Wybrana ilość jest większa niż dostępna');
              return;
            }
            const newParts = Object.assign([], parts);
            if (currPart !== -1 && !newParts[currPart].release_id) {
              newParts[currPart].quantity = newQuantity;
            } else {
              newParts.push({
                id: type.current.value,
                quantity: quantity.current.value,
                reinvoice: reinvoice.current.value,
                label: partConf.label,
                unit: 'SZT',
                category: cat
              })
            }
            setParts(newParts);
          }}>Dodaj</a>
        </fieldset>
      </fieldset>
    </div>
  </div>);
}
